// extracted by mini-css-extract-plugin
module.exports = {"created-by":"created-by-3d1di","createdBy":"created-by-3d1di","icon":"icon-352bQ","profile-photo":"profile-photo-3KVJ8","profilePhoto":"profile-photo-3KVJ8"};